export default `---
slug: malaysia
country: Malaysia
countryCode: MYS
continent: Asia
year: 2024
title: "Malaysia — Kuala Lumpur for Work"
description: "Two weeks in Kuala Lumpur on a business trip that turned into an unexpected adventure."
thumbnail: /images/travels/MYS/malaysia_thumb.jpg
relatedLinks: []
---
![malaysia](/images/travels/MYS/malaysia_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Malaysia and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
